import { render, staticRenderFns } from "./ShowAdmins.vue?vue&type=template&id=a2b44f76&scoped=true"
import script from "./ShowAdmins.vue?vue&type=script&lang=js"
export * from "./ShowAdmins.vue?vue&type=script&lang=js"
import style0 from "./ShowAdmins.vue?vue&type=style&index=0&id=a2b44f76&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2b44f76",
  null
  
)

export default component.exports